export const debounce = (func, timeout) => {
	let timer
	return (...args) => {
		clearTimeout(timer)
		timer = setTimeout(() => { func.apply(this, args) }, timeout)
	}
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/modules/debounce.js